import React from "react"
import {
    HorizontalStack,
    componentStyles,
    useColors,
} from "@mallardbay/lib-react-components"

import AnimatedTypingDot from "~components/shared/motion/animated-typing-dot"
import { TEST_IDS } from "~config/constants"

const DOT_KEYS = ["typing-dot-0", "typing-dot-1", "typing-dot-2"] as const

export default function ChatTypingIndicator() {
    const styles = useStyles()

    return (
        <HorizontalStack
            style={styles.bubble}
            testId={TEST_IDS.CHAT_TYPING_INDICATOR}
        >
            {DOT_KEYS.map((key, index) => (
                <AnimatedTypingDot key={key} index={index} />
            ))}
        </HorizontalStack>
    )
}

function useStyles() {
    const colors = useColors()

    return componentStyles({
        bubble: {
            alignItems: "center",
            gap: 1,
            paddingY: 3,
            paddingX: 4,
            borderRadius: "lg",
            backgroundColor: colors.bgSecondary,
        },
    })
}
